import { z } from "zod/v4";

import { OnsiteInjectionsCodeTypeList } from "../onsite-injections";

export const AiOnsiteInjectionsContextSchema = z.object({
  pageHtml: z.string().optional(),
  currentCode: z.string().optional(),
});
export type AiOnsiteInjectionsContextType = z.infer<
  typeof AiOnsiteInjectionsContextSchema
>;

export const AiOnsiteInjectionsRequestMetadataSchema = z.object({
  prompt: z.string(),
  codeType: z.enum(OnsiteInjectionsCodeTypeList),
  context: AiOnsiteInjectionsContextSchema.optional(),
  domain: z.string().optional(),
});

export type AiOnsiteInjectionsRequestMetadataType = z.infer<
  typeof AiOnsiteInjectionsRequestMetadataSchema
>;
